export const PRODUCT_CARD_ACTION = 'productCardAction';
export const DEFAULT_LANG = 'en';
export const VARIANT_TYPE = {
  SHADE: 'Shade',
  SIZE: 'Size',
};
export const ROOT = 'root';
export const SELECT = 'select';
export const TRACKING_PAGE_TYPES = {
  HOMEPAGE: 'homepage',
  PLP: 'plp',
  SEARCH: 'search',
  PDP: 'pdp',
  NLP: 'nlp',
  NOT_FOUND: 'not found',
  SEARCH_INPUT: 'search_input',
  BEST_SELLERS: 'bestSellers',
};

export const SNACKBAR_ID = 'add-to-cart-prompt';
export const WISHLIST_SNACKBAR_ID = 'wishlist-prompt';
export const ADDTOBAG_WITHOUT_SIZE = 'addToBag-withoutSize';

export const TRACKING_EVENTS = {
  REMOVE_FROM_WISHLIST: 'removeFromWishlist',
  ADD_TO_CART: 'addToCart',
  NOTIFY_ME: 'notifyMe',
  ADD_TO_WISHLIST: 'addToWishlist',
};

export const DEFAULT_PRODUCT_TRACKING = {
  isProductWidget: false,
  device: 2,
  tierName: 'non_prive',
};

export const EVENT_MAP = {
  wishlistAddition: 'add_to_wishlist',
  cartAdditionSuccess: 'add_to_cart',
  wishlistRemove: 'remove_from_wishlist',
};
